export default __webpack_public_path__ + "static/media/canara_hsbc.3e525fcf.png";